import { Panel } from 'primereact/panel';
import { useTranslation } from "react-i18next";
import { formatarParaMoedaBRL, formatarCPF } from "../../../utils";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';

export default function ProtestoNacionalCpf({ data }: { data: any }) {
  const { t } = useTranslation();

  const identificacao = data?.sinteseCadastral;
  const resumo = data?.resumoProtestos;

  const formatarDataNascimento = (valor?: string) => {
    if (!valor || valor.length < 10) return valor;
    const [ano, mes, dia] = valor.substring(0, 10).split('-');
    return `${dia}/${mes}/${ano}`;
  };

  const resumos = [
    { icon: 'pi pi-file', label: t('quantidade'), value: resumo?.total ?? 0 },
    {
      icon: 'pi pi-dollar',
      label: t('valor'),
      value: resumo?.valorTotalNumerico != null ? formatarParaMoedaBRL(Number(resumo.valorTotalNumerico)) : '0',
    },
  ];

  return (
    <Panel header={t('protestoNacionalCpf')}>
      {identificacao && (
        <div className="grid">
          {[
            { label: t('cpf'), value: formatarCPF(identificacao.cpf) },
            { label: t('nome'), value: identificacao.nome },
            { label: t('dataNascimento'), value: formatarDataNascimento(identificacao.dataNascimento) },
            { label: t('nomeMae'), value: identificacao.nomeMae },
            { label: t('condicaoCpf'), value: identificacao.condicaoCpf },
          ].map(f => (
            <div key={f.label} className="col p-fluid flex flex-wrap">
              <div>
                <label className="label-dados">{f.label}</label>
                <div>{f.value || '—'}</div>
              </div>
            </div>
          ))}
        </div>
      )}
      <br></br>
      <div className="flex-consulta flex-wrap gap-3">
        {resumos.map((item, index) => (
          <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }} key={index}>
            <div className="flex-consulta justify-content-between gap-5">
              <div className="flex-consulta flex-column gap-1">
                <span style={{ color: 'white' }} className="text-sm">{item.label}</span>
                <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
              </div>
              <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                <i className={item.icon} />
              </span>
            </div>
          </Card>
        ))}
      </div>
      <br></br>
      <DataTable size="small" value={data?.protestos} tableStyle={{ minWidth: '50rem' }}>
        <Column field="tipo" header={t('tipo')}></Column>
        <Column field="cartorio" header={t('cartorio')}></Column>
        <Column field="data" header={t('data')}></Column>
        <Column field="cidade" header={t('cidade')}></Column>
        <Column field="uf" header={t('uf')}></Column>
        <Column field="valor" header={t('valor')}></Column>
      </DataTable>
    </Panel>
  );
}
